export default __webpack_public_path__ + "assets/images/peergame-logo-dark-c0113a4c814cefe37e7c345c7034d934.svg";